<template>
  <div>
    <div class="app-container">
      <div class="container-page">
        <!-- 任务大盘 -->
        <div class="title-box">
          <span class="title">磁盘用量统计</span>
        </div>

        <!-- 操作按钮 -->
        <div class="operator-box">
          <el-row :gutter="32" type="flex" class="panel-group">
            <el-col :span="6" class="card-panel-col" v-for="(item, index) in panelList" :key="index">
              <div class="card-panel" :class="{
                  red: item.id == 1,
                  blue: item.id == 2,
                  purple: item.id == 3,
                  yellow: item.id == 99,
                  active: currentId == item.id,
                }" @click="handlePanel(item)">
                <div class="card-panel-text">{{ item.name }}</div>
                <span class="card-panel-num">{{ item.total | handleFileSize }}</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 筛选条件 -->
        <div class="filter-container filter-box">
          <div class="left-box">

          </div>

          <div class="right-box">
            <el-button class="filter-item button_add" type="primary" @click="handleExport">
              <i class="el-icon-download" />
              <span class="button_span">导出</span>
            </el-button>
          </div>
        </div>

        <!-- 表格 -->
        <el-table ref="table" class="grayTableTile_02" v-loading="tableloading" :data="tableList" :header-cell-style="{ 'background-color': '#f7f7f7', color: '#999' }" @sort-change="sortFun" :row-key="(row, index) => `row_${index}_${row.name || ''}_${row.type || ''}`">
          <el-table-column v-for="item of tableTheads" :key="Object.keys(item)[0]" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" :sortable="item['sortable']" show-overflow-tooltip :min-width="180">
            <template slot-scope="scope">
              <!-- 需求标题 -->
              <span v-if="Object.keys(item)[0] == 'name'">
                <span v-if="scope.row.url && scope.row.url != ''" @click="handleView(scope.row)" class="titleClass">{{
                  scope.row.name
                }}</span>
                <span v-else>{{ scope.row.name }}</span>
              </span>
              <!-- 正常展示 -->
              <span v-else>
                <span v-if="Object.keys(item)[0] == 'allSize' || Object.keys(item)[0] == 'img' || Object.keys(item)[0] == 'video' || Object.keys(item)[0] == 'other'">{{ scope.row[Object.keys(item)[0]] | handleFileSize }}</span>
                <span v-else-if="Object.keys(item)[0] == 'type'">{{ scope.row[Object.keys(item)[0]] | handleType }}</span>
                <span v-else>
                  {{ scope.row[Object.keys(item)[0]] }}
                </span>
              </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <pagination class="pagination" style="padding-bottom:0px" v-show="total > 0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" />

        <el-table v-show="false" id="xiazaitable" v-loading="tableloading" :data="caseTable" height="1">
          >
          <el-table-column v-for="item of tableTheads" :key="Object.keys(item)[0]" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" :sortable="item['sortable']" show-overflow-tooltip :min-width="180">
            <template slot-scope="scope">
              <!-- 需求标题 -->
              <div v-if="Object.keys(item)[0] == 'name' && scope.row.url && scope.row.url != ''">
                <span @click="handleView(scope.row)" class="titleClass">{{
                  scope.row.name
                }}</span>
              </div>
              <!-- 正常展示 -->
              <span v-else>
                <span v-if="Object.keys(item)[0] == 'allSize' || Object.keys(item)[0] == 'img' || Object.keys(item)[0] == 'video' || Object.keys(item)[0] == 'other'">{{ scope.row[Object.keys(item)[0]] | handleFileSize }}</span>
                <span v-else-if="Object.keys(item)[0] == 'type'">{{ scope.row[Object.keys(item)[0]] | handleType }}</span>
                <span v-else>{{ scope.row[Object.keys(item)[0]] }}</span>
              </span>
            </template>
          </el-table-column>

        </el-table>
      </div>

    </div>
    <diskInfo ref="diskInfo"></diskInfo>
  </div>
</template>
<script>
import CountTo from "vue-count-to";
import Pagination from "@/components/Pagination";
import DiskInfo from "./components/info.vue";
import {
  outsource_flowStatusNum,
  outsource_flowList,
} from "@File~/api/outsourcing";
import { getFileSizeTotal_ajax } from "@File~/api/file";
import { arrSlice, sortKeys } from "@/filters";
import FileSaver from 'file-saver'
import * as XLSX from "xlsx";
const defaultFormThead = [
  { name: "名称" },
  { type: "资源归类" },
  { allSize: "总资源占用量", sortable: "custom" },
  { img: "图片占用量", sortable: "custom" },
  { video: "视频占用量", sortable: "custom" },
  { other: "其他占用量", sortable: "custom" },
];

const defaultFormThead2 = [
  { name: "名称" },
  { type: "资源归类", sortable: "custom" },
  { allSize: "总资源占用量", sortable: "custom" },
];

export default {
  components: { CountTo, Pagination, DiskInfo, XLSX },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      panelList: [
        {
          id: 99,
          name: "总资源占用量",
          total: 0,
        },
        {
          id: 1,
          name: "美宣素材占用量",
          total: 0,
        },
        {
          id: 2,
          name: "团队空间占用量",
          total: 0,
        },
        {
          id: 3,
          name: "共享磁盘占用量",
          total: 0,
        }
      ],

      currentId: null, // 当前面版
      currentPage: null, // 当前面版

      sortColumn: "createTimeStr1",
      sortType: "DESC",


      // 表格
      tableloading: false,
      tableTheads: defaultFormThead,
      originalCaseTable: [], // 原始数据
      caseTable: [], // 排序后数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10,
      },

      // 评价 临时
      evaluateList: [
        {
          name: "质量",
          score: 3,
        },
        {
          name: "服务",
          score: 3,
        },
        {
          name: "守时",
          score: 3,
        },
        {
          name: "经验",
          score: 3,
        },
        {
          name: "性价比",
          score: 3,
        },
      ],
    };
  },

  filters: {
    // 状态
    statusFilter(status) {
      // const statusMap = {
      //   1: "待审批",
      //   2: "进行中",
      //   3: "待验收",
      //   4: "待结算",
      //   5: "已完成",
      //   -1: "已拒绝"
      // };
      let statuStr = "";
      switch (status) {
        case 1:
          statuStr = "待审批";
          break;
        case 2:
          statuStr = "进行中";
          break;
        case 3:
          statuStr = "待验收";
          break;
        case 4:
          statuStr = "待结算";
          break;
        case 5:
          statuStr = "已完成";
          break;
        case -1:
          statuStr = "已拒绝";
          break;
      }
      // return statusMap[status];
      return statuStr;
    },
  },
  computed: {
    // 筛选列表表
    tableList() {
      let caseTable = this.caseTable;

      if (caseTable.length > 0) {
        // 将一维数组切割成二维数组
        const handCaseTable = arrSlice(caseTable, this.listQuery.pageSize);

        // 检查当前页码是否超出范围
        let currentPageNo = this.listQuery.pageNo;
        if (currentPageNo > handCaseTable.length) {
          currentPageNo = 1;
          // 使用nextTick异步更新pageNo，避免在computed中直接修改data
          this.$nextTick(() => {
            this.listQuery.pageNo = 1;
          });
        }

        // 确保数组索引有效
        const pageIndex = currentPageNo - 1;
        const tableData = handCaseTable[pageIndex] || [];

        return tableData;
      } else {
        return [];
      }
    },
  },

  watch: {
    // 监听caseTable变化，更新total
    caseTable: {
      handler(newVal) {
        this.total = newVal.length;
      },
      immediate: true
    }
  },
  created() {
    this.currentId = this.panelList[0].id;
    this.currentPage = this.panelList[0];
    this.getList();
  },
  filters: {
    handleFileSize(value) {
      if (value / 1024 / 1024 / 1024 > 1024) {
        return (value / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
      } else if (value / 1024 / 1024 > 1024) {
        return (value / 1024 / 1024 / 1024).toFixed(2) + ' GB'
      } else if (value / 1024 > 1024) {
        return (value / 1024 / 1024).toFixed(2) + ' MB'
      } else if (value / 1024) {
        return (value / 1024).toFixed(2) + ' KB'
      } else {
        return '0'
      }
    },
    handleType(value) {
      const typeMap = {
        1: "美宣素材",
        2: "团队空间",
        3: "共享磁盘",
      };
      return typeMap[value];
    },

  },
  methods: {
    reload() {
      this.$nextTick(() => {
        this.getList();
      });
    },

    // 获取列表
    getList() {

      let data = {
      };
      this.tableloading = true;
      getFileSizeTotal_ajax(data).then((response) => {
        if (response.code == 1) {

          // 处理数据 - 先重置所有total为0
          this.panelList.forEach(panel => {
            panel.total = 0;
          });

          // 根据type累加allSize到对应的panelList项
          response.data.forEach(item => {
            for (let element of this.panelList) {
              if (item.type === element.id) {
                element.total += item.allSize;
              }
            }
          });

          // 将id为1、2、3的total加总到id为99的total上
          let totalSum = 0;
          this.panelList.forEach(panel => {
            if (panel.id != 99) {
              totalSum += panel.total;
            }
          });

          // 找到id为99的panel并设置total
          const totalPanel = this.panelList.find(panel => panel.id === 99);
          if (totalPanel) {
            totalPanel.total = totalSum;
          }

          // 根据this.currentId过滤数据
          if (this.currentId != 99) {
            response.data = response.data.filter(item => item.type === this.currentId);
          } else {
            response.data = response.data
          }

          if (this.currentId == 99 || this.currentId == 1) {
            this.tableTheads = defaultFormThead
          } else {
            this.tableTheads = defaultFormThead2
          }

          this.total = response.data.length;
          // this.tableList = response.data.result;

          this.caseTable = response.data;
          this.originalCaseTable = JSON.parse(JSON.stringify(response.data));
          this.tableloading = false;
        }
      });
    },

    sortFun(e) {
      // console.log(this.caseTable)

      // if (e.order) {
      //     this.sortColumn = e.prop
      //     this.sortType = e.order == 'ascending' ? 'ASC' : 'DESC'
      // } else {
      //   //默认
      //   this.sortColumn = 'createTimeStr'
      //   this.sortType = 'DESC'
      // }
      if (e.order) {
        const order = e.order == "descending" ? false : true;
        this.caseTable.sort(sortKeys(e.prop, order));
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable));
      }

      // this.listQuery.pageNo = 1
      // this.getList()
    },

    // 查询
    handleFilter() {
      this.listQuery.pageNo = 1;
      this.getList();
    },

    // 操作面板
    handlePanel(item) {
      this.listQuery.pageNo = 1;
      console.log(item)
      this.currentId = item.id;
      this.currentPage = item;
      this.getList();

      // 清除表格排序状态
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.clearSort();
        }
      });
    },

    // 导出
    handleExport() {
      // 获取当前时间并格式化
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      // 格式话时间 格式化月 日 时 分 秒 小于10的补0
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      hour = hour < 10 ? '0' + hour : hour;
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      const time = year + '-' + month + '-' + day + '-' + hour + '-' + minute + '-' + second;

      if (this.currentPage.name != "") {
        var name = this.currentPage.name + time;
      } else {
        var name = "磁盘用量统计";
      }
      /* generate workbook object from table */
      var table = document.querySelector("#xiazaitable");
      var wb = XLSX.utils.table_to_book(table);
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },

    // 查看详情
    handleView(row) {
      const url = window.location.origin + row.url;
      window.open(url, '_blank');
    },

  },
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 16px 32px 61px;
  min-height: calc(100vh - 50px);
  overflow: hidden;
  background: #f5f5f5;
}
.container-page {
  // height: calc(100vh - 71px);
  padding: 24px 24px;
  background: #ffffff;
  border-radius: 4px;
  position: relative;
}
.title-box {
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 23px;
  .title {
    line-height: 22px;
    font-size: 16px;
    color: #333333;
  }
  .icon {
    font-size: 16px;
    margin-left: 8px;
    cursor: pointer;
  }
}
.operator-box {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;

  .card-panel {
    padding: 16px 20px;
    border-radius: 4px;
    cursor: pointer;
    .card-panel-text {
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      margin-bottom: 4px;
    }
    .card-panel-num {
      font-size: 24px;
      font-weight: bold;
      color: #333333;
      line-height: 30px;
    }
    &.active {
      box-shadow: 0px 4px 10px 4px rgba(0, 0, 0, 0.07),
        0px 3px 5px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -2px rgba(0, 0, 0, 0.12);
    }
  }
  .red {
    background: #ffe9eb;
  }
  .blue {
    background: #e3f1fb;
  }
  .purple {
    background: #f2ecfe;
  }
  .yellow {
    background: #fff1e6;
  }
  .green {
    background: #dbf8ec;
  }
  .gray {
    background: #eeeeee;
  }
}
.filter-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
  .button_span {
    margin-left: 4px;
  }

  ::v-deep .el-input__inner {
    background: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    color: #333;
  }

  // ::v-deep .el-icon-arrow-up:before {
  //   content: "\E78F";
  //   color: #666;
  // }
}
.right-box {
  flex-shrink: 0;
  width: 240px;
  text-align: right;
}
// input search
.input_search {
  ::v-deep .el-input__inner {
    padding-left: 44px;
  }
  ::v-deep .el-input__prefix {
    width: 20px;
    height: 20px;
    margin: 8px 12px 8px 12px;
    .icon {
      width: 20px;
      height: 20px;
    }
  }
}
// 新增按钮
.button_add {
  padding: 10px 16px;
  margin-left: 16px;
}
.button_filter {
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  padding: 10px 12px;
}
// 表格
.grayTableTile_02 {
  .line {
    display: inline-block;
    width: 2px;
    height: 16px;
    background: #ccc;
    vertical-align: middle;
    margin: 0 3px;
  }

  ::v-deep .el-table__fixed {
    height: 623px !important;
  }
  ::v-deep .el-table__fixed-right {
    height: 623px !important;
  }

  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px; // 横向滚动条
    height: 10px; // 纵向滚动条 必写
  }
  // 滚动条的滑块
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 5px;
  }

  ::v-deep .red td:first-child {
    border-left: 4px solid #fb6c75;
  }
  ::v-deep .blue td:first-child {
    border-left: 4px solid#439DE2;
  }
  ::v-deep .purple td:first-child {
    border-left: 4px solid #876fff;
  }
  ::v-deep .yellow td:first-child {
    border-left: 4px solid #ffa356;
  }
  ::v-deep .green td:first-child {
    border-left: 4px solid #0ed27f;
  }
  ::v-deep .gray td:first-child {
    border-left: 4px solid#CCCCCC;
  }
  .titleClass {
    width: 200px;
    color: #3a89ff;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover {
      text-decoration: underline;
    }
  }
  .delayCellClass {
    display: inline-block;
    height: 16px;
    background-color: #e22b4b;
    color: #fff;
    font-size: 12px;
    line-height: 12px;
    border-radius: 8px;
    padding: 2px 5px;
  }
  .vnumsClass {
    color: #3a89ff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  .butn-style {
    display: block;
    max-width: 120px;
    width: 100%;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 4px;
    color: #333333;
    cursor: pointer;
  }
  .butn-style.red {
    background: #ffe9eb;
  }
  .butn-style.blue {
    background: #e3f1fb;
  }
  .butn-style.purple {
    background: #f2ecfe;
  }
  .butn-style.yellow {
    background: #fff1e6;
  }
  .butn-style.green {
    background: #dbf8ec;
  }
  .butn-style.gray {
    background: #eeeeee;
  }
  .empty {
    color: #333333;
  }
}

// 评分
// ::v-deep .score-popper{
//     padding: 16px 16px 8px;
//     ::v-deep .el-popover__title{
//         font-size: 14px;
//         font-weight: 500;
//         color: #333333;
//         line-height: 20px;
//         margin-bottom: 8px;
//     }
// }
.comment-box {
  display: flex;
  flex-flow: row wrap;
  .comment-item {
    width: 50%;
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 6px;
  }
  .label {
    min-width: 36px;
    font-size: 12px;
    color: #666666;
    margin-right: 8px;
    line-height: 18px;
  }
}
::v-deep .el-rate__icon {
  margin-right: 0;
  font-size: 20px;
}

// 表格固定 滚动
// .grayTableTile_02 ::v-deep .el-table__body-wrapper {
//     z-index: 1;
// }

// table 定位有条线
::v-deep .el-table__fixed-right:before,
::v-deep .el-table__fixed:before {
  background-color: transparent;
}

.select-box {
  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 60%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }
  ::v-deep .el-select-dropdown__item {
    padding: 0 20px 0 10px;
  }
  ::v-deep .el-select-dropdown__item.selected::after {
    right: 5px;
  }
}

.dateClass {
  ::v-deep .el-icon-date:before {
    content: url("../../assets/date.png");
    position: absolute;
    top: 6px;
    left: 10px;
  }
}
</style>